import React from 'react';

type TranslationResourceProps = {
  message?: string;
  parameters?: Record<string, unknown>;
};

export type FieldTranslateFn = (
  key: string,
  options?: Record<string, unknown>
) => string;

export function normalizeFieldErrorMessage(
  message: unknown,
  t: FieldTranslateFn
): string | undefined {
  if (!message) {
    return undefined;
  }

  if (typeof message === 'string') {
    return message;
  }

  if (React.isValidElement<TranslationResourceProps>(message)) {
    const { message: translationKey, parameters } = message.props;

    if (translationKey) {
      return t(translationKey, parameters);
    }
  }

  return undefined;
}

export const emptyFieldHelperText = '\u00A0';
